import { AiFillEye, AiFillEdit, AiFillDelete } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { isEmpty, startCase } from 'lodash'
import { BsArrowUpShort } from 'react-icons/bs'
import helpers from 'utils/helpers'

const JobsManagerList = ({
  jobsList,
  page,
  sort,
  setSort,
  handleView,
  handleEdit,
  handleApproveJob,
  handleDeleteJob
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className='p-3'>
        <div className='rounded-lg overflow-x-auto relative border'>
          <table className='dark:text-gray-400 w-full text-xs text-left text-[#6c6c6c] '>
            <thead className='dark:bg-gray-700 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  Sr no.
                </th>
                <th
                  scope='col'
                  className='px-6 cursor-pointer py-3 '
                  onClick={() => {
                    const newSortType = sort.sortType === 'asc' ? 'desc' : 'asc'
                    setSort({
                      sortBy: 'name',
                      sortType: newSortType
                    })
                  }}
                >
                  <div className='flex justify-start'>
                    <span>{t('JOB_TITLE')}</span>
                    <span>
                      {sort.sortBy === 'name' && (
                        <BsArrowUpShort
                          className={`w-4 h-4 ${sort.sortType === 'asc' ? '' : 'rotate-180'
                            }`}
                        />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='px-6 py-3 '>
                  {t('COMPANY')}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_COUNTRY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STATE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_CITY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("CATEGORY")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("SUBCATEGORY")}
                </th>
                <th
                  scope='col'
                  className='px-6 cursor-pointer py-3 '
                  onClick={() => {
                    const newSortType = sort.sortType === 'asc' ? 'desc' : 'asc'
                    setSort({
                      sortBy: 'createdAt',
                      sortType: newSortType
                    })
                  }}
                >
                  <div className='flex justify-start'>
                    <span>{t('CREATED_DATE')}</span>
                    <span>
                      {sort.sortBy === 'createdAt' && (
                        <BsArrowUpShort
                          className={`w-4 h-4 ${sort.sortType === 'asc' ? '' : 'rotate-180'
                            }`}
                        />
                      )}
                    </span>
                  </div>
                </th>
                <th className='text-center py-3 px-6 ' scope='col'>
                  {t('O_STATUS')}
                </th>
                <th scope='col' className='px-6 text-center py-3'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {jobsList && jobsList.length > 0 ? (
                jobsList.map((job, i) => {
                  return (
                    <tr
                      key={i}
                      className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                    >
                      <th
                        scope='row'
                        className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                      >
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className='px-6 border-r py-4 text-gray-900'>
                        {job?.name}
                      </td>
                      <td className='border-r py-4 px-6 text-gray-900'>
                        {job?.Company?.name} {/* You might want to fetch company name here */}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">{job?.Country?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{job?.State?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{job?.city}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{job?.Category?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{job?.subCategory?.name}</td>
                      <td className='py-4 px-6 border-r text-gray-900'>
                        {new Date(job?.createdAt).toLocaleDateString()}
                      </td>
                      <td className='py-4 px-6 border-r text-gray-900 text-center'>
                        {job?.adminStatus === "pending" || !job?.adminStatus ? (
                          <div className="flex justify-center space-x-2">
                            <button
                              onClick={() => handleApproveJob(job._id, "accepted")}
                              className="bg-green-500 text-white px-3 py-1 rounded text-xs hover:bg-green-600"
                            >
                              Accept
                            </button>
                            <button
                              onClick={() => handleApproveJob(job._id, "rejected")}
                              className="bg-red-500 text-white px-3 py-1 rounded text-xs hover:bg-red-600"
                            >
                              Reject
                            </button>
                          </div>
                        ) : (
                          <span className={`px-2 py-1 rounded-full text-xs ${job?.adminStatus === "accepted"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                            }`}>
                            {job?.adminStatus === "accepted" ? "Accepted" : "Rejected"}
                          </span>
                        )}
                      </td>
                      <td className='px-6 border-l py-4 text-gray-900'>
                        <div className='flex justify-center space-x-2'>
                          <button
                            onClick={() => handleView(job)}
                            className='hover:text-blue-600'
                            title='View Job'
                          >
                            <AiFillEye className='h-5 w-5' />
                          </button>

                          <button
                            // onClick={() => handleDeleteJob(job._id)}
                            onClick={() => helpers.alertFunction(`Are you sure want to delete '${job.name}'?`, job._id, handleDeleteJob, true)}
                            className='hover:text-red-600'
                            title='Delete Job'
                          >
                            <AiFillDelete className='h-5 w-5' />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr className='bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6 border-r' colSpan={9}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default JobsManagerList